import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import './Checkbox.scss';

const Checkbox = ({ className = '', checked = false, disabled = false, label = '', onChange = () => {}, ...props }) => {
	return (
		<div className={classNames('Checkbox', className, { disabled })}>
			<label className='Checkbox__label'>
				<input type='checkbox' checked={checked} disabled={disabled} onChange={onChange} {...props} />
				<div className='Checkbox__mark-box'>
					<div className='Checkbox__mark'></div>
				</div>
				{label && <div className='Checkbox__label-element'>{label}</div>}
			</label>
		</div>
	);
};

Checkbox.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	onChange: PropTypes.func,
};

export default Checkbox;
